module.exports = __webpack_public_path__ + "static/media/lung.beb325e7.svg";